module.exports = __webpack_public_path__ + "static/media/Template_41.1b8508cf.png";